import { render, staticRenderFns } from "./zhuanti-chengshigengxin.vue?vue&type=template&id=51ffe52a&"
import script from "./zhuanti-chengshigengxin.vue?vue&type=script&lang=js&"
export * from "./zhuanti-chengshigengxin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports